export default __webpack_public_path__ + "static/media/sampleDerpy1.88d216a4.gif";